import { cn } from "@newxsystems/shared";
import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import type { ISimpleHeroStandardProps } from "./SimpleHeroStandard.props";

export const SimpleHeroStandard = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroStandardProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);

  return (
    <BlockContainer anchorId={anchorId} parentClass={parentClass} spacing={spacing}>
      <div className={cn("w-full max-w-[720px]", alignment === "center" ? "mx-auto" : "mx-0")}>
        <BlockCommonContent
          alignment={alignment}
          className="w-full"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingLevel="h1"
        />
        {buttons?.length ? (
          <BlockActions
            actions={buttons}
            alignment={alignment}
            className={cn("w-full", hasCommonContent && "mt-8")}
          />
        ) : null}
      </div>
    </BlockContainer>
  );
};

SimpleHeroStandard.displayName = "SimpleHero::SimpleHeroStandard";
